import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  providerId: string().required(),
  questionnaireId: string().required(),
})

export const url = ({ providerId, questionnaireId }) => `v1/providers/${providerId}/questionnaire/${questionnaireId}`
